import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button } from '@material-ui/core'
import { dashboardFilterFormValidation } from '../../utils/validationSchema'
import { FormLoader } from '../../components/Loader/FormLoader'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'
import FormRadioGroupField from '../FormRadioGroupField'
import FormDateField from '../FormDateField'
import moment from 'moment'
import { getQuarterDate } from '../../utils/helpers'
import DateFnsUtils from '@date-io/date-fns'
import arSA from 'date-fns/locale/ar-SA'
import enUS from 'date-fns/locale/en-US'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import CustomToolbarMonth from '../../components/HomePageContent/CustomToolbarMonth'

const DashboardFilterForm = ({ onSubmit, cancelDialog, currentData, locale }) => {
  const intl = useIntl()
  const classes = formStyles()
  const [type, setType] = React.useState(currentData.type)
  const [quarter, setQuarter] = React.useState(currentData.quarter || '1')
  const [year, setYear] = React.useState(new Date(currentData?.year))
  const [month, setMonth] = React.useState(new Date(currentData?.month))

  const formActions = useFormik({
    initialValues: {
      type: '',
      year: '',
      month: '',
      quarter: '',
      dateFrom: '',
      dateTo: ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: dashboardFilterFormValidation,
    onSubmit: ((values, formikHelpers) => {
      onSubmit(values, formikHelpers)
    })
  })
  React.useEffect(() => {
      if (!!Object.keys(currentData || {}).length) {
        formActions.setValues(currentData)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const types = [
    { key: 'quarterly', name: intl.formatMessage({ id: 'Fields.label.dashboard.type.quarterly' }) },
    { key: 'monthly', name: intl.formatMessage({ id: 'Fields.label.dashboard.type.monthly' }) }
  ]

  let quarters = [
    {
      key: '1',
      name: intl.formatMessage({ id: 'Fields.label.dashboard.quarter.1' }),
      disabled: moment(getQuarterDate(1, new Date(year).getFullYear().toString())).isAfter(moment())
    },
    {
      key: '2',
      name: intl.formatMessage({ id: 'Fields.label.dashboard.quarter.2' }),
      disabled: moment(getQuarterDate(2, new Date(year).getFullYear().toString())).isAfter(moment())
    },
    {
      key: '3',
      name: intl.formatMessage({ id: 'Fields.label.dashboard.quarter.3' }),
      disabled: moment(getQuarterDate(3, new Date(year).getFullYear().toString())).isAfter(moment())
    },
    {
      key: '4',
      name: intl.formatMessage({ id: 'Fields.label.dashboard.quarter.4' }),
      disabled: moment(getQuarterDate(4, new Date(year).getFullYear().toString())).isAfter(moment())
    }
  ]

  const handleYearDateChange = (date) => {
    setYear(date)
    formActions.setFieldValue('year', date || '')
    formActions.setFieldValue('dateFrom', getQuarterDate(parseInt(quarter), new Date(date).getFullYear().toString()))
    formActions.setFieldValue('dateTo', getQuarterDate(parseInt(quarter), new Date(date).getFullYear().toString(), true))
  }

  const handleMonthDateChange = (date) => {
    setMonth(date)
    // formActions.setFieldValue('year', date || '')
    formActions.setFieldValue('month', date || '')
    formActions.setFieldValue('dateFrom', moment(date).startOf('month').toDate())
    formActions.setFieldValue('dateTo', moment(date).endOf('month').toDate())
  }

  React.useEffect(() => {
      if (!!quarter) {
        formActions.setFieldValue('dateFrom', getQuarterDate(parseInt(quarter), new Date(formActions.values.year).getFullYear().toString()))
        formActions.setFieldValue('dateTo', getQuarterDate(parseInt(quarter), new Date(formActions.values.year).getFullYear().toString(), true))
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [quarter])

  React.useEffect(() => {
      if (type === 'monthly') {
        // formActions.setFieldValue('year', month || '')
        // formActions.setFieldValue('month', month || '')
        formActions.setFieldValue('dateFrom', moment(month).startOf('month').toDate())
        formActions.setFieldValue('dateTo', moment(month).endOf('month').toDate())
      } else if (type === 'quarterly') {
        formActions.setFieldValue('dateFrom', getQuarterDate(parseInt(formActions.values.quarter), new Date(formActions.values.year).getFullYear().toString()))
        formActions.setFieldValue('dateTo', getQuarterDate(parseInt(formActions.values.quarter), new Date(formActions.values.year).getFullYear().toString(), true))
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [type])

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
      <form onSubmit={formActions.handleSubmit} noValidate autoComplete="off" className={classes.formWrapper}>

        <FormRadioGroupField name={'type'} labelKey={'Fields.label.dashboard.type'} list={types}
                             classes={classes} formActions={formActions} row returnValue={setType}/>

        {formActions.values.type === 'quarterly' ? <>
          <FormDateField name={'year'} labelKey={'Fields.label.dashboard.year'}

                         classes={classes} formActions={formActions} disableFuture
                         value={year} format={'yyyy'} row noClear
                         handleChange={handleYearDateChange}
                         atts={{
                           views: ['year'],
                           todayLabel: intl.formatMessage({ id: 'Fields.label.dashboard.year.todayBtn' })
                         }}/>
          <FormRadioGroupField name={'quarter'} labelKey={'Fields.label.dashboard.quarter'} list={quarters}
                               classes={classes} formActions={formActions} row column
                               returnValue={setQuarter}/>

        </> : <FormDateField name={'month'} labelKey={'Fields.label.dashboard.month'}
                             classes={classes} formActions={formActions} disableFuture
                             value={month} format={'MMMM yyyy'} row noClear
                             handleChange={handleMonthDateChange}
                             atts={{
                               views: ['month'],
                               ToolbarComponent: CustomToolbarMonth,
                               todayLabel: intl.formatMessage({ id: 'Fields.label.dashboard.month.todayBtn' })
                             }}/>}


        <div className={classes.FormSubmitRow}>
          <Button type="submit" variant='contained' size={'large'} color={'secondary'}
                  onClick={formActions.handleSubmit}
                  disabled={formActions.isSubmitting || !formActions.isValid}
          >
            <FormattedMessage id={`dashboard.filter.submit`}/>
          </Button>
          <Button variant='outlined' color='secondary'
                  onClick={cancelDialog} className={'cancel'}>
            <FormattedMessage id='invoiceSteps.Cancel'/>
          </Button>
        </div>
        {!!formActions.isSubmitting && <FormLoader loading={true}/>}
      </form>
    </MuiPickersUtilsProvider>
  )
}

export default DashboardFilterForm
